var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "grcreport"
  }, [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-1"
  }, [_c('div', {
    staticClass: "card-header filter_main"
  }, [_c('i', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse1",
      modifiers: {
        "collapse1": true
      }
    }],
    staticClass: " fa fa-filter filter",
    attrs: {
      "data-toggle": "collapse",
      "aria-expanded": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-actions"
  })]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "visible": "",
      "id": "collapse1"
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "",
      "method": "post"
    }
  }, [(_vm.showSelectClient || _vm.showSelectWarehouse) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.merchant')) + " ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-group'></i>"
    }
  }, [_c('basic-select', {
    staticClass: "form-control",
    staticStyle: {
      "height": "32px",
      "padding": "8px",
      "padding-left": "13px",
      "border-radius": "0%"
    },
    attrs: {
      "options": _vm.listMerchantData1,
      "placeholder": _vm.$t('common.merchantPlaceholder'),
      "selected-option": _vm.item
    },
    on: {
      "select": _vm.onSelect
    },
    model: {
      value: (_vm.merchant),
      callback: function($$v) {
        _vm.merchant = $$v
      },
      expression: "merchant"
    }
  })], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('userList.userType')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "username"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.username = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('reports.selectUsername')))]), _vm._v(" "), _vm._l((_vm.listuserData), function(user_obj) {
    return _c('option', {
      domProps: {
        "value": user_obj.email
      }
    }, [_vm._v(_vm._s(user_obj.email))])
  })], 2)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 datepicker"
  }, [_c('label', [_vm._v(" " + _vm._s(_vm.$t('reports.transactionFromDate')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-calendar-plus-o'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder'),
      "format": "YYYY-MM-DD"
    },
    model: {
      value: (_vm.transactionfromdate),
      callback: function($$v) {
        _vm.transactionfromdate = $$v
      },
      expression: "transactionfromdate"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 datepicker"
  }, [_c('label', [_vm._v(" " + _vm._s(_vm.$t('reports.transactionToDate')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-calendar-plus-o'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder'),
      "format": "YYYY-MM-DD"
    },
    model: {
      value: (_vm.transactiontodate),
      callback: function($$v) {
        _vm.transactiontodate = $$v
      },
      expression: "transactiontodate"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "float-right"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.getgrreportDataSearch(2)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" " + _vm._s(_vm.$t('common.searchBtn')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" " + _vm._s(_vm.$t('common.resetBtn')))])])])])])])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-headerfrm"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3 col-4 cardlistheader"
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('reports.goodReceiptReport')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-8  cardlistheader"
  }, [_c('b', {
    staticStyle: {
      "font-family": "cursive,fantasy"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('common.table.heading')) + " -   " + _vm._s(this.formattedDate))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-4 "
  }, [_c('b', {
    staticStyle: {
      "font-family": "cursive,fantasy",
      "color": "green"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.$t('common.table.count')) + " - " + _vm._s(this.totalRows))])]), _vm._v(" "), (_vm.download && _vm.listProductivitygrData.length > 0) ? _c('div', {
    staticClass: "col-md-2 col-8"
  }, [_c('button', {
    staticClass: "btn btn-info downloadbutton",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.Choosetype(1)
      }
    }
  }, [_vm._v("  " + _vm._s(_vm.$t('printProductDetails.download')))])]) : _vm._e(), _vm._v(" "), (_vm.show && _vm.listProductivitygrData.length > 0) ? _c('div', {
    staticClass: "col-md-1 col-3"
  }, [_c('button', {
    staticClass: "btn btn-info downloadbutton",
    attrs: {
      "title": "Download CSV"
    },
    on: {
      "click": function($event) {
        _vm.getgrreportData(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])]) : _vm._e(), _vm._v(" "), (_vm.show && _vm.listProductivitygrData.length > 0) ? _c('div', {
    staticClass: "col-md-1 col-3"
  }, [_c('download-excel', {
    staticClass: "btn btn-info downloadbutton",
    attrs: {
      "before-generate": _vm.startDownload,
      "before-finish": _vm.finishDownload,
      "title": "Download Excel",
      "header": _vm.dataFilter2,
      "data": _vm.listReportDataforxls,
      "fields": _vm.csvFieldsForXls,
      "worksheet": "MyWorksheet",
      "name": _vm.reportname
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable",
    attrs: {
      "id": "my-table"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('userList.userName')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('manifestReport.table.columns.merchantName')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('reports.transcationDate')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('reports.totalSKUsreceived')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('reports.totalqtyreceived')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('reports.totalqtyaccepted')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('reports.totalqtyrejected')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('removeHold.totalHoldQty')))])])])]), _vm._v(" "), _c('tbody', [(_vm.client == '' && _vm.warehouse == '') ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "16",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.table.noClientNoWarehouseMsg')))])]) : _vm._e(), _vm._v(" "), (_vm.client == '' && _vm.warehouse != '') ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "16",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.table.noClientMsg')))])]) : _vm._e(), _vm._v(" "), (_vm.client != '' && _vm.warehouse == '' && _vm.listProductivitygrData == '') ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "16",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.warehouseSelectHolder')))])]) : _vm._e(), _vm._v(" "), (_vm.client != '' && _vm.warehouse != '' && _vm.searchFlag == false) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "16",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.table.noSearchBtnMsg')))])]) : _vm._e(), _vm._v(" "), (_vm.resultCount == 0 && _vm.client != '' && _vm.warehouse != '' && _vm.searchFlag == true) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "16",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.table.noRecordFoundMsg')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.listProductivitygrData), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(data.createdby))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.merchantname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(data.grccreateddate))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.totalsku))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.receivedqty))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.acceptedqty))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.rejectedqty))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.holdqty))])])
  })], 2)])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.totalPage && _vm.listProductivitygrData.length > 0) ? _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPage,
      "total": _vm.totalRows,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPage
    },
    on: {
      "pagechanged": _vm.onPageChange
    }
  }) : _vm._e()], 1)])])])], 1)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-21b5d83d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21b5d83d","hasScoped":true}!./src/views/components/productivity report/productivitygrreport/productivitygrreport.component.html
// module id = 1680
// module chunks = 0